import styled, { css } from 'styled-components'

interface DatePickerInputStyledProps {
  error?: boolean
  disabled?: boolean
  focused?: boolean
  block?: boolean
}

export const DatePickerInputStyled = styled.div<DatePickerInputStyledProps>`
  display: ${(props) => (props.block ? 'flex' : 'inline-flex')};
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.form.datepicker.border};
  border-radius: ${(props) =>
    props.theme.typography.pxToRem(props.theme.shape.borderRadius)};
  height: ${(props) => props.theme.typography.pxToRem(36)};
  cursor: pointer;

  background-color: ${(props) => props.theme.colors.contentBackground};

  ${(props) =>
    props.error &&
    css`
      border-color: ${props.theme.colors.form.datepicker.borderError};
    `}
  ${(props) =>
    props.focused &&
    css`
      border-color: ${props.theme.colors.primary};
    `}
    ${(props) =>
    props.disabled &&
    css`
      background-color: ${props.theme.colors.form.datepicker
        .backgroundDisabled};
      cursor: default;
    `}
    input {
    flex: 1;
    font-family: ${(props) => props.theme.typography.fontFamily};
    font-size: ${(props) => props.theme.typography.pxToRem(14)};
    font-weight: ${(props) => props.theme.typography.fontWeightRegular};
    line-height: ${(props) => props.theme.typography.pxToRem(36)};
    padding: 0 ${(props) => props.theme.typography.pxToRem(12)};
    border: 0;
    background: none;
    outline: none;
    width: ${(props) =>
      props.block ? '50%' : props.theme.typography.pxToRem(100)};
    height: 100%;

    &::placeholder {
      color: ${(props) => props.theme.colors.text.placeholder};
    }

    &:disabled {
      color: ${(props) => props.theme.colors.text.disabled};
      cursor: default;
    }
  }
`
